import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService, UserService } from '@thiememeulenhoff/ng-security';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@thiememeulenhoff/ng-sdk';
import { catchError, EMPTY, switchMap } from 'rxjs';

@Component({
  imports: [RouterModule, AsyncPipe, TranslatePipe],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  #authService = inject(AuthService);

  #userService = inject(UserService);

  readonly user$ = this.#userService.user$;

  readonly loginFailed = signal(false);

  ngOnInit(): void {
    this.#authService
      .login()
      .pipe(
        catchError(() => {
          this.loginFailed.set(true);
          return EMPTY;
        }),
        switchMap(() => this.#userService.fetchUser()),
      )
      .subscribe();
  }
}
